import classNames from 'classnames';

import Text from 'components/BaseHelpers/Text';
import { OtherCollegeNavigationProps } from 'components/Core/CoreNavigationHeader/components/OtherCollegeNavigation';
import SubNavLinks from 'components/Core/CoreNavigationHeader/components/OtherCollegeNavigation/components/SubNavLinks';

import styles from '../OtherCollegeNavigation.module.scss';

type SubNavProps = OtherCollegeNavigationProps['dropdownMenu'] & { open: boolean };

const SubNav = ({ currentSite, dropdownOptions, open }: SubNavProps) => {
  const { label, description } = currentSite;

  return (
    <div
      className={classNames(styles.subNav, {
        [styles['subNav--open']]: open,
      })}
    >
      <ul aria-labelledby="other-college-nav-label">
        <li className={classNames(styles.navItem, styles['navItem--current-site'])}>
          <div className={styles.copyWrapper}>
            <p className={styles.label}>
              <Text field={label} />
            </p>
            {!!description && (
              <p className={styles.description}>
                <Text field={description} />
              </p>
            )}
          </div>
        </li>
        <SubNavLinks options={dropdownOptions} />
      </ul>
    </div>
  );
};

export default SubNav;
